import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useUpdateFocusedViewLockMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IUser) => void;
}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ userId, locked }: { userId: string; locked: boolean }) => {
			return userSession.webServiceHelper.callAsync<Api.IUser>(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: { locked },
					urlPath: `user/${userId}/preferences/coffee/focusedViewLocked`,
				}),
				'PUT'
			);
		},
		onError,
		onSuccess,
	});
}
